<script lang="ts">
  import { loc } from "module/utils";
  import { stores } from "module/store/SettingsStore";
  import type { ModuleSetting } from "module/store/ModuleSettings";

  import FormGroup from "./FormGroup.svelte";

  let {
    label,
    setting,
    notes,
    sub,
    disabled,
  }: {
    label: string;
    setting: ModuleSetting;
    notes?: string | undefined;
    sub?: boolean;
    disabled?: boolean;
  } = $props();

  const value = stores[setting];

  const registration = game.settings.settings.get(`quick-insert.${setting}`);
  const type = registration?.type;

  const options = Object.entries(registration?.choices || {}).map(
    ([id, title]) => ({ id, title: loc(title as string) })
  );

  let select: HTMLSelectElement;
</script>

<FormGroup {sub}>
  <label for={setting}>{label}</label>
  <div class="form-fields">
    <select
      bind:this={select}
      name={setting}
      id={setting}
      value={$value.toString()}
      on:blur={() =>
        ($value = type === Number ? parseFloat(select.value) : select.value)}
      {disabled}
    >
      {#each options as option (option.id)}
        <option value={option.id.toString()}>{option.title}</option>
      {/each}
    </select>
  </div>
  {#if notes}
    <p class="hint">
      {notes}
    </p>
  {/if}
</FormGroup>

<style>
  label {
    white-space: nowrap;
  }
</style>
